var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 100,
    height: 100,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8bb7f0",
    d: "M4.893,36.471c0.787-1.35,1.711-3,2.56-4.577l0.199-0.37l-0.329-0.26 C3.568,28.296,1.5,24.296,1.5,20C1.5,11.453,9.799,4.5,20,4.5S38.5,11.453,38.5,20S30.201,35.5,20,35.5 c-2.173,0-4.339-0.332-6.436-0.985l-0.163-0.051l-0.16,0.06C10.296,35.618,7.254,36.322,4.893,36.471z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4e7ab5",
    d: "M20,5c9.925,0,18,6.729,18,15s-8.075,15-18,15c-2.123,0-4.239-0.324-6.287-0.962l-0.326-0.102 l-0.32,0.119c-2.521,0.936-5.108,1.583-7.26,1.831c0.671-1.171,1.402-2.487,2.086-3.756l0.398-0.739l-0.658-0.52 C4,28.001,2,24.14,2,20C2,11.729,10.075,5,20,5 M20,4C9.507,4,1,11.163,1,20c0,4.601,2.32,8.737,6.013,11.656 C5.947,33.635,4.837,35.596,4,37c2.597,0,6.172-0.803,9.415-2.007C15.47,35.633,17.681,36,20,36c10.493,0,19-7.163,19-16 S30.493,4,20,4L20,4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.4c7cac5dffc4aa34b651476212bfea89.svg";
export { ForwardRef as ReactComponent };